import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { fetchSupport } from './support-data.actions';

@Injectable()
export class SupportDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchSupport() {
    this._store.dispatch(fetchSupport());
  }
}
